Ext.define('SA.view.sidebar.data.DataSearchWindow', {
    alias: 'widget.data-search-window',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-data-search-window',
    floating: true,

    items: [
        {
            xtype: 'simple-container',
            cls: 'sa-data-search-header',

            items: [
                {
                    xtype: 'data-search-conditions'
                }, {
                    xtype: 'close-button',
                    closeAction: 'hide',
                    margin: '4 0 0 0'
                }
            ]
        }, {
            xtype: 'simple-container',
            cls: 'sa-data-search-body',
            itemId: 'body',

            items: [
                {
                    xtype: 'data-search-facet-browser'
                }, {
                    xtype: 'simple-container',
                    cls: 'sa-data-search-results-wrap',

                    items: [
                        {
                            xtype: 'sa-text-field',
                            clearButton: true,
                            cls: 'sa-data-search-filter-field',
                            emptyText: 'Filter',
                            icon: true,
                            itemId: 'searchTextField',
                            ui: 'compact'
                        }, {
                            xtype: 'component',
                            cls: 'sa-data-search-results-mask',
                            hidden: true,
                            html: 'Searching…',
                            itemId: 'mask'
                        }, {
                            xtype: 'data-search-no-results',
                            hidden: true,
                            text: 'No results found. Please adjust your search parameters.'
                        }, {
                            xtype: 'data-search-results',
                            disableHierarchy: !SA.Features.hasHierarchicalDataSearch()
                        }
                    ]
                }
            ]
        }, {
            xtype: 'component',
            cls: 'sa-data-search-footer'
        }
    ],

    initComponent() {
        this.callParent();

        this.updateSize();

        SA.Viewport.on('resize', this.updateSize, this);

        this.conditionList = this.down('data-search-conditions');
        this.body = this.down('#body');
        this.searchTextField = this.down('#searchTextField');
        this.mask = this.down('#mask');
        this.noResults = this.down('data-search-no-results');
        this.results = this.down('data-search-results');
        this.facetBrowser = this.down('data-search-facet-browser');

        this.queryManager = new SA.data.DataSearchQueryManager({
            scope: this,
            beforeQuery: this.beforeQuery,
            onFacets: this.onFacets,
            onResults: this.onResults
        });

        this.facetBrowser.setCountry(this.country);
    },

    beforeQuery() {
        if (this.queryManager.getPage() === 1) {
            Ext.suspendLayouts();

            this.mask.show();
            this.results.scrollToTop();

            this.refreshConditions({total: 'Loading'});

            Ext.resumeLayouts(true);
        }
    },

    getBodyHeight() {
        return this.body.el.getHeight();
    },

    getResultAttributeIds() {
        return this.results.getAttributeIds();
    },

    initEvents() {
        this.callParent();

        this.conditionList.on('click:conditionRemoveBtn', this.onClickConditionRemoveBtn, this);
        this.searchTextField.on('change', this.onChangeSearchTextField, this, {buffer: 250});

        this.results.on('select', this.onSelectVariable, this);
        this.results.on('click:path', this.onResultsPathClick, this);
        this.results.el.on('scroll', this.onResultsScroll, this);

        this.facetBrowser.on({
            'change:ageRange': this.onChangeAgeRange,
            'change:facetGroupSelections': this.onChangeFacetGroupSelections,
            'change:facetItemSelection': this.onChangeFacetItemSelection,
            'change:incomeRange': this.onChangeIncomeRange,

            scope: this
        });
    },

    onChangeAgeRange(range) {
        this.queryManager.setAgeRange(range);
    },

    onChangeFacetItemSelection(facetId, value) {
        this.queryManager.setFacet(facetId, value);
    },

    onChangeFacetGroupSelections(selections) {
        selections.forEach(({facetId, selected}) => {
            this.queryManager.setFacet(facetId, selected ? 'true' : null);
        });
    },

    onChangeIncomeRange(range) {
        this.queryManager.setIncomeRange(range);
    },

    onChangeSearchTextField() {
        this.queryManager.setFilterText(this.searchTextField.getValue());
    },

    onClickConditionRemoveBtn(type, facet, value) {
        switch (type) {
            case 'filterText':
                this.searchTextField.setValue('');
            break;

            case 'text':
                this.fireEvent('clear:text', this);
                this.setText('');
            break;

            case 'ageRange':
                this.facetBrowser.clearAgeRange();
            break;

            case 'incomeRange':
                this.facetBrowser.clearIncomeRange();
            break;

            case 'vendor':
                this.facetBrowser.deselectVendor(value);
            break;

            default:
                this.facetBrowser.deselectFacet(facet, value);
        }
    },

    onDestroy() {
        this.callParent();

        SA.Viewport.un('resize', this.updateSize, this);

        Ext.destroyMembers(this, 'queryManager');
    },

    onFacets({facets}) {
        this.facetBrowser.setFacets(facets);
    },

    onResults(response) {
        var qm = this.queryManager,
            page = this.maxLoadedPage = qm.getPage(),
            {results, total} = response;

        if (!SA.Features.hasHierarchicalDataSearch()) {
            results = results.map(result => ({result}));
        }

        Ext.suspendLayouts();

        this.onFacets(response);

        this.totalResults = total;

        this.mask.hide();

        if (page === 1) {
            this.results.clear();
        }

        this.results.addResults(results);

        this.refreshConditions({total});

        this.noResults.setVisible(total === 0);

        Ext.resumeLayouts(true);
    },

    onResultsPathClick(path, dataset) {
        var censusReleaseYear = SA.AppController.getCurrentModelCensusRelease(),
            year = this.down('data-search-year-radio-group').getSelected(),
            year = year === 'Latest' ? SA.data.Vendors.getDatasetModel(dataset).getLatestEditionForCensusReleaseYear(censusReleaseYear) : Number(year);

        this.fireEvent('click:path', path, dataset, year);
    },

    onResultsScroll() {
        var qm = this.queryManager,
            resultsEl = this.results.el.dom,
            scrolledNearBottom = resultsEl.scrollHeight - resultsEl.clientHeight - resultsEl.scrollTop < 50,
            moreResultsAvailable = this.totalResults > this.maxLoadedPage * qm.getPageSize(),
            hasPendingRequest = qm.getPage() > this.maxLoadedPage;

        if (scrolledNearBottom && moreResultsAvailable && !hasPendingRequest) {
            qm.setPage(this.maxLoadedPage + 1);
        }
    },

    onSelectVariable(list, attribute) {
        this.fireEvent('select', this, attribute);
    },

    refreshConditions({total}) {
        var qmState = this.queryManager.getState(),
            data = Object.assign(qmState, {
                total,
                country: this.country
            });

        this.conditionList.setData(data);
    },

    removeCategory() {
        this.facetBrowser.removeCategory();
    },

    selectCategory(category) {
        this.facetBrowser.selectCategory(category);

        this.queryManager.selectCategory(category);
    },

    setArrowTarget(target) {
        this.getPlugin('sa-arrow').setTarget(target);
    },

    setSelectedVariables(variables) {
        this.results.setSelected(variables);
    },

    setText(text) {
        this.queryManager.setText(text);
    },

    setView(view) {
        this.censusRelease = view.getCensusRelease();
        this.country = view.getCountry();

        this.facetBrowser.setCountry(this.country);

        this.queryManager.setView(view);
    },

    setYearFacet(year) {
        this.facetBrowser.setYearFacet(year);

        this.queryManager.setFacet('year', year);
    },

    updateSize() {
        var sidebarWidth = SA.Sidebar.getWidth();

        Ext.suspendLayouts();

        this.setHeight(Math.max(300, Ext.dom.Element.getViewportHeight() - 100));
        this.setWidth(Ext.Number.constrain(Ext.dom.Element.getViewportWidth() - sidebarWidth, sidebarWidth, 840));

        Ext.resumeLayouts(true);
    }
});